    <script lang="ts">
    import {api, DataType} from "src/services/api/reallis"
    import {delay, validateEmail, navigate} from "src/components/#common/helpers"
    import {Link} from 'svelte-routing'
    import Alert from 'src/components/#common/alert/Alert.svelte'
    import spinIcon from '../../../../materials/images/spin.svg'
    import {doShow as showAlert} from "src/components/cabinet/#common/alert/store"
    import {isLoggedIn} from 'src/services/auth'
    import {onDestroy} from "svelte"

    onDestroy(isLoggedIn.subscribe(value => {
        if (value) {
            navigate("/")
        }
    }))

    export let hash = null

    let email = ''
    let password = ''
    let errorStatus = false
    let errorText = ''
    let rememberMe = false
    let sending = false

    async function login() {
        if (!email) {
            errorStatus = true
            errorText = 'Enter your Email'
            return
        }

        const _email = email
        if (!validateEmail(email)) {
            errorStatus = true
            errorText = 'Please enter a valid Email'
            return
        }

        if (password == '') {
            errorStatus = true;
            errorText = 'Enter your Password'
            return
        }

        try {
            sending = true
            errorStatus = false;

            await api.ws.ws1.login({
                username: _email.toLowerCase(),
                password: password,
                sessionTime: rememberMe ? 0 : 24 * 60 * 60 * 1000 , //  0 (disabled) or 24 hours
            })

            email = ''
            password = ''
        } catch (err) {
            if (err.message == 'Account disabled') {
                showAlert.set({
                    status: 'message',
                    text: 'You have not confirmed Email. Confirmation email has been sent again.'
                })
            } else if (err.code === 'user-banned') {
                navigate('/ban')
                return
            } else {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            }
        } finally {
            sending = false
        }
    }
</script>

<svelte:head>
    <title>Login</title>
</svelte:head>

<div class="panel-wrapper">
    <div class="container">
        <form class="panel" on:submit|preventDefault={login} novalidate>
            <Alert />
            <div class="section-title">Dashboard</div>
            <div class="input-group">
                <input type="email" id="EmailInput" class="form-control field" placeholder="Your E-mail"
                   autocomplete="email" required bind:value={email}>
            </div>
            <div class="input-group">
                <input type="password" class="form-control field" placeholder="Your Password"
                   autocomplete="password" required bind:value={password}></div>
            <div class="text-center">
                <div class="invalid-feedback">Please enter a valid email.</div>
            </div>
            <!--
            <div class="input-group">
                <label for="remember" class="remember">
                    <input class="form-check-input" type="checkbox" id="remember" bind:checked={rememberMe}>Remember me
                </label>
            </div>
            -->
            <div class="text-center">
                <div class="invalid-feedback {errorStatus ? 'd-block' : ''}">{errorText}</div>
                <input type="submit" class="input-group-text btn btn-primary {sending ? 'loading' : ''}" disabled={sending} value="Login">
            </div>
        </form>
    </div>
</div>

<style lang="postcss">
    :global {
        @import 'src/styles/app.pcss';
    }
    .panel {
        background: #272C33;
        border-radius: 10px;
        padding: 0 0 30px;
    }

    .panel-wrapper {
        background: #1c1d21;
        padding-top: 200px;
        font-size: 1rem;
        line-height: 1.5;
        font-weight: 400;
        font-family: 'Rubik', sans-serif;
        height: 100%;
        overflow: hidden;
        width: 100%;
    }

    .section-title {
        font-size: 34px;
        position: relative;
        text-align: center;
        color: white;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 35px;
        padding-top: 30px;
    }

    .input-group {
        max-width: 550px;
        margin: 10px auto;
    }

    label {
        color: white;
        font-size: 15px;
        line-height: 30px;
        position: relative;
        cursor: pointer;
    }

    input[type="checkbox"] {
        font-size: 20px;
        position: relative;
        cursor: pointer;
    }

    input {
        margin: 5px 0;
    }

    .btn.btn-primary {
        margin: 5px auto 20px;
    }

    .remember input {
        margin-right: 10px;
    }

    @media(max-width: 991px) {
        .panel-wrapper {
            padding-top: 150px;
            padding-bottom: 150px;
        }
    }

    @media(max-width: 767px) {
        .section-title {
            font-size: 30px;
            margin-bottom: 20px;
        }

        .panel {
            padding: 15px 15px 10px;
        }
    }
</style>
